<template>
	<div class="c-schedule__wrap"
        :data-component-name="$options.name"
	>
        <FloatingDateRangePicker
            @set-current-date="$emit('set-current-date', $event)"
            :currentDate="currentDate"
        />
		<div class="c-load-prev-week" ref="loadPrevWeek">
			<q-spinner
				color="primary"
				size="2em"
			/>
		</div>
		<div class="c-load-next-week" ref="loadNextWeek">
			<q-spinner
				color="primary"
				size="2em"
			/>
		</div>
		<div class="c-schedule">
			<ScheduleHeader
				:currentDate="currentDate"
            	:weekrange="headerWeekrange"
           		@set-date-offset="dateOffset=$event"
				@set-current-date="$emit('set-current-date', $event)"
				@scroll-passive="syncScroll($event)"
				ref="headerScroll"
				v-if="headerWeekrange"
			/>

			<div class="c-schedule-week -push"
			>
				<div class="c-schedule-col"
					:key="wdp"
					v-for="(weekday, wdp) in weekdays"
					:class="{'-weekend' : weekday.date.getDay()==0 || weekday.date.getDay()==6}"
				></div>
			</div>

			<div class="c-schedule-week -schedule js-schedule"
				@scroll.passive="syncScroll($event)"
				ref="weekScroll"
			>
				<div class="c-schedule-col -scrollableX js-col"
					:key="wd"
					v-for="(weekday, wd) in weekdays"
					:class="{'-weekend' : weekday.date.getDay()==0 || weekday.date.getDay()==6}"
				>
					<div
						class="c-schedule-event -absence"
						:key="absence.id"
						v-for="absence in datedAbsences[weekday.dateStr]"
						:style="'left: 0; top:'+absencesTop+'px; width:100%;'"
					>
						<div>
							<!-- <q-avatar :style="'background-color:'+hexColorFromString(absence.type.name)" text-color="white" size="16px" /> -->
							<q-icon name="event_busy" size="24px" class="q-mr-sm"></q-icon>
							{{ absence.type.name }}
						</div>
					</div>
					<div
						class="c-schedule-event -nd"
						:key="wda"
						v-for="(assignment, wda) in weekday.assignments"
						:style="'left: '+assignment.pos_x+'%;top:'+assignment.pos_y+'px; height:'+assignment.pos_height+'px; width:'+assignment.pos_width+'%;'"
						:class="assignment.state"
						:id="assignment.container_id"
					>
						<div class="c-schedule-event__content">
							<div class="c-schedule-event__name">
								<strong>
									{{ assignment.project.name }}
                        			<ProjectCardToggle class="float-right" :projectID="assignment.project.id" :myAssignments="true" :projectShiftID="assignment.projectShift.id" :size="'24px'" />
									<!-- <SvgIcon name="alert" /> -->
								</strong>
								<div>de {{ assignment.displayed_start_time.split(':')[0] + ':' + assignment.displayed_start_time.split(':')[1] + ' à ' + assignment.displayed_end_time.split(':')[0] + ':' + assignment.displayed_end_time.split(':')[1]}}<br><div v-if="assignment.isDayOverlap" style="font-size:0.65rem">(...suite)</div></div>
								<div class="">
									{{ assignment.profession.name }}
								</div>
							</div>
							<hr>
							<div class="c-schedule-event__desc">
								<!-- {{ assignment.projectShift.name }}<br> -->
								<!-- {{ assignment.projectShift.description }} -->
								<!-- {{ assignment.id }} -->
								<!-- <pre>{{ assignment.acceptation }}</pre> -->
								<!-- {{ assignment.pos_y }}<br>
								{{ assignment.pos_height}}<br>
								{{ assignment.start_time}}<br>
								{{ assignment.end_time}}<br>
								{{ assignment.dateStart}}<br>
								{{ assignment.dateEnd}}<br> -->
								<!-- <pre>{{ weekday.assignments }}</pre> -->
							</div>
						</div>
						<div class="c-schedule-event__controls">
							<div class="-assignmenterror text-center q-mb-md" v-if="assignment.hasAssignmentError">
								<q-icon name="error_outline" size="xs" /> Conflit d'horaire!
							</div>
							<AcceptationSelect
								:userProfileID="userProfileID"
								:lastDenyReason="lastDenyReason"
								v-model="assignment.acceptation"
								:maybeButton="maybeButton"
								:canceled="assignment.canceled"
								v-if="assignment.acceptation"
								@accept-assignment="acceptAssignment($event, assignment.id)"
								@confirm-cancel="confirmAssignmentCancel(assignment.id)"
							/>

							<AcceptationSelect
								:userProfileID="userProfileID"
								:lastDenyReason="lastDenyReason"
								v-model="assignment.acceptation"
								v-else
								@accept-assignment="acceptAssignment($event, assignment.id)"
							/>
						</div>
					</div>


				</div>
			</div>

			<div class="c-schedule__bg">
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">0:00</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">0:30</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">1:00</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">1:30</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">2:00</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">2:30</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">3:00</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">3:30</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">4:00</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">4:30</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">5:00</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">5:30</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">6:00</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">6:30</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">7:00</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">7:30</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">8:00</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">8:30</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">9:00</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">9:30</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">10:00</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">10:30</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">11:00</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">11:30</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">12:00</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">12:30</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">13:00</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">13:30</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">14:00</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">14:30</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">15:00</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">15:30</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">16:00</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">16:30</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">17:00</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">17:30</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">18:00</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">18:30</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">19:00</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">19:30</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">20:00</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">20:30</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">21:00</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">21:30</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">22:00</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">22:30</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">23:00</div>
				</div>
				<div class="c-schedule__bg-row">
					<div class="c-schedule__hour">23:30</div>
				</div>
			</div>
		</div>
		<!-- <q-popup-proxy>
			<q-banner>
			<template v-slot:avatar>
				<q-icon name="signal_wifi_off" color="primary" />
			</template>
			You have lost connection to the internet. This app is offline.
			</q-banner>
      	</q-popup-proxy> -->
		<CommunicationPopup
			ref="CommunicationPopup"
			v-model="CommunicationPopup"
		/>
	</div>
</template>

<script>
	import ScheduleHeader from "@/components/nav/ScheduleHeader";
	import AcceptationSelect from "@/components/forms/AcceptationSelect"
    import {getWeeksLimits, getDatesBetween, dayOfWeekStr, monthStr, dayStr} from '@/js/dateUtilities'
    import { MYPROFILE } from '@/graphql/user/queries'
    import { USERASSIGNMENTS } from "@/graphql/assignment/queries";
    import { ACCEPTNOTIFICATIONASSIGNMENT } from "@/graphql/notification/mutations"
    import { CONFIRMASSIGNMENTCANCEL } from "@/graphql/assignment/mutations"
	import { USERABSENCES } from "@/graphql/absence/queries"
    import moment from 'moment';
    import orderBy from "lodash/orderBy";
    import uniqBy from 'lodash/uniqBy'
    import {hexColorFromString} from '@/js/utilities'
    import FloatingDateRangePicker from '@/components/nav/FloatingDateRangePicker'

	export default {
		name: "ScheduleCalendar",
		components: {
			ScheduleHeader,
			AcceptationSelect,
			FloatingDateRangePicker
		},
		props: {
            currentDate: String,
			inboxUserProfileID: {
				type: [Number, String],
				default: null,
			}
		},
		data(){
			return {
				userProfileID: null,
				CommunicationPopup: false,
				scrollTo: null,
				scrollWeek: false,
				debug: null,
				lazyDate: null,
				headerWeekrange: null,
				loadingNextWeek: false,
				loadingPrevWeek: false,
				lastDay: null,
				firstDay: null,
				noCacheUpdate: false,
				weekdays: [],
				scrollToEventTO: {},
				maybeButton: "Peut-être",
				lastDenyReason: null,
				datedAbsences: {},
				absencesTop: '0px',
				bodyScollTo: null
				// maybeButton: false
			}
		},
		watch:{
			weekrange: function(){
				this.loadingNextWeek=true;
				this.loadingPrevWeek=true

				this.headerWeekrange=this.weekrange;
				this.lastDay=this.weekrange.obj.to
				this.firstDay=this.weekrange.obj.from
				this.$refs.weekScroll.scrollLeft=0
				this.$refs.headerScroll.$refs.headerScroll.scrollLeft=0;
			},
			inboxUserProfileID: function(){
				if(this.inboxUserProfileID) this.userProfileID=this.inboxUserProfileID;
			}
		},
		computed: {
			weekrange(){
                return getWeeksLimits(this.currentDate, this.$generalSettings.settings.firstDayOfWeek)
			},
		},
		methods: {
            hexColorFromString(string){
                return hexColorFromString(string)
            },
			log(msg){
				console.log(msg)
			},
			scrollToEvent(event){
				clearTimeout(this.scrollToEventTO);
				this.scrollToEventTO=setTimeout(function(){
					document.querySelector('body').classList.remove('q-body--prevent-scroll');
					if(!event){
						this.$scrollTo(document.querySelector('body'), 0, {offset: 420});
					}else{
						this.$scrollTo( document.querySelector("#assignment-"+event.id), 100,
							{
								offset: -140,
								onDone: function(){
									this.$scrollTo( document.querySelector("#assignment-"+event.id), 100,
										{
											x: true,
											container: ".js-schedule",
										}
									)
								}.bind(this)
							}
						)
					}
					this.loadingNextWeek=false;
					this.loadingPrevWeek=false

				}.bind(this), 100);
			},
			computeWeekdays(userAssignments){
				if(!this.lastDay) return [];
				if(!this.firstDay) return [];
				userAssignments=this.computeAssignments(userAssignments);
				let dateRange=getDatesBetween(this.firstDay, this.lastDay)
				let weekdays=[]
				dateRange.forEach(function(date){
                    let dateStr=moment(date).format('YYYY-MM-DD');
					let weekday={
						date: date,
						dateStr: dateStr,
                        day: dayStr(date.getDate()),
                        dayOfWeekStr: dayOfWeekStr(date),
						monthStr: monthStr(date),
						assignments: []
					}
					if(userAssignments) weekday.assignments = userAssignments.data.filter(function(e){
						return e.date==dateStr;
					})
					if(weekday.assignments.length>1){
						weekday.assignments=orderBy(weekday.assignments, [item => item.pos_y])
						let divider=1;
						let i=0, j=0, y1, y2, yy1, yy2, groups=[];
						let assignments=weekday.assignments;

						for(i=0; i<assignments.length; i=j){
							let group=[];
							group.push(i);
							y1=parseInt(assignments[i].pos_y);
							y2=y1+parseInt(assignments[i].pos_height);

							for(j=i+1; j<assignments.length; j++){
								yy1=parseInt(assignments[j].pos_y);
								yy2=yy1+parseInt(assignments[j].pos_height);
								if(y1-1<yy2 && y2+1>yy1){
									group.push(j);
									y1=Math.min(y1, yy1);
									y2=Math.max(y2, yy2);
								}else{
									break;
								}
							}

							groups.push(group)
						}
 						
						groups.forEach(function(group){
							if(group.length>1) {
								divider=group.length;
								let i=0;
								group.forEach(function(item){
									weekday.assignments[item].pos_x=i*(100/divider)
									weekday.assignments[item].pos_width=100/divider
									i++;
								})
							}
						})
						// Object.keys(groups).forEach(function(key){
						// 	divider=groups[key].length
						// 	let index=1;
						// 	groups[key].forEach(function(assignment){
						// 		assignment.pos_x=index*(100/divider);
						// 		assignment.pos_width=100/divider;
						// 		index++;
						// 	})
						// })
					// 	// weekday.assignments.forEach(function (assignment, index){
					// 	// 	assignment.pos_x=index*(100/divider);
					// 	// 	assignment.pos_width=100/divider;
					// 	// })
					}
                    weekdays.push(weekday)
				})
                return weekdays

			},
			computeAssignments(assignments){
				let assignmentFollow={};
				if(!assignments?.data) return false;

				assignments.data.forEach(function(assignment){
					assignmentFollow={};
					if(!assignment.container_id) assignment.container_id="assignment-"+assignment.id;
					if(!assignment.displayed_start_time) assignment.displayed_start_time=assignment.start_time;
					if(!assignment.displayed_end_time) assignment.displayed_end_time=assignment.end_time;

					if(assignment.end_time<assignment.start_time){
						assignmentFollow=JSON.parse(JSON.stringify(assignment));
						assignmentFollow.date=new moment(assignmentFollow.date).add(1, 'days').format('YYYY-MM-DD');
						assignmentFollow.start_time="00:00:00";
						assignmentFollow.container_id="assignment-"+assignment.id+"-2";
						assignmentFollow.isDayOverlap=true;
						assignments.data.push(assignmentFollow)
						
						assignment.end_time='23:59:59';
					}
				})

				assignments.data.forEach(function(assignment){
					assignmentFollow={};
					let dateFlat=new Date(new moment(assignment.date+ ' 00:00:00'));
					let dateStart=new Date(new moment(assignment.date+ ' '+assignment.start_time))
					let dateEnd=new Date(new moment(assignment.date+ ' '+assignment.end_time))

					assignment.date_start=new moment(assignment.date+ ' '+assignment.start_time).format('YYYYMMDD hh:mm:ss');
					assignment.pos_y=(dateStart.getTime() - dateFlat.getTime()) / 1000 / 60;
					assignment.pos_x=0;
					if(!assignment.container_id) assignment.container_id="assignment-"+assignment.id;

					if(!assignment.displayed_start_time) assignment.displayed_start_time=assignment.start_time;
					if(!assignment.displayed_end_time) assignment.displayed_end_time=assignment.end_time;

					assignment.pos_height=(dateEnd.getTime() - dateStart.getTime()) / 1000 / 60;
					assignment.pos_width=100;
					assignment.dateEnd=dateEnd;
					assignment.dateStart=dateStart;

					assignment.state='-completed'
					assignment.acceptation={
						label: 'Acceptée',
						value: 'accepted',
						icon: 'verified',
						currentClass: '-completed'
					}
					if(assignment.deniedByUser){
						assignment.state='-alert'
						assignment.acceptation={
							label: 'Refusée',
							value: 'denied',
							icon: 'new_releases',
							currentClass: '-denied'
						}
					}
					if(assignment.maybeByUser){
						assignment.state='-published'
						assignment.acceptation={
							label: 'Peut-être',
							value: 'maybe',
							icon: 'help',
							currentClass: '-maybe'
						}
					}
					if(assignment.notification_pending || assignment.notification_send){
						assignment.acceptation={
							label: 'En attente',
							value: null,
							icon: 'pending_actions',
							currentClass: '-maybe'
						}

						assignment.state='-published'
					}

					if(assignment.hasAssignmentError) {
						// assignment.acceptation=null;
						assignment.state='-alert'
					}

					if(assignment.canceled) {
						// assignment.acceptation=null;
						assignment.state='-canceled'
						assignment.acceptation={
							label: 'Ne plus afficher',
							value: 'cancel',
							icon: 'help',
							// currentClass: '-canceled'
						}

					}

				})
				
				assignments.data=uniqBy(assignments.data, 'container_id');
				return {data: orderBy(assignments.data, [item => item.date_start])};
			},
			syncScroll(event){
				if(event.target.classList.contains('c-schedule-week')){

					let columnWidth=document.querySelector(".js-col").offsetWidth
					let scrollableWeekWidth=columnWidth*7
					let scrollableWidth=columnWidth*document.querySelectorAll(".js-col").length
					let loadingNext=scrollableWidth-(columnWidth*4)
					let loadingPrev=(scrollableWeekWidth-columnWidth)/2;
					
					this.$refs.headerScroll.$refs.headerScroll.scrollLeft=this.$refs.weekScroll.scrollLeft;

					clearTimeout(this.scrollTo);
					if( !this.loadingNextWeek && !this.loadingPrevWeek){
						this.scrollTo=setTimeout(function(){
							if( !this.loadingNextWeek && this.$refs.weekScroll.scrollLeft+5 >= loadingNext ){
								this.loadingNextWeek=true;
								this.loadWeek()
							}else if( !this.loadingPrevWeek && this.$refs.weekScroll.scrollLeft <=  loadingPrev){
								this.loadingPrevWeek=true;
								let lastScrollPos=this.$refs.weekScroll.scrollLeft;
								this.loadWeek(function(){
									this.$nextTick(function () {
										this.$refs.weekScroll.scrollLeft=scrollableWeekWidth+lastScrollPos
										this.$refs.headerScroll.$refs.headerScroll.scrollLeft=scrollableWeekWidth+lastScrollPos;
										this.loadingPrevWeek=false;
									}.bind(this))
								}.bind(this))
							}
						}.bind(this), 200)
					}
				}
			},
			communicate(){
				// if(popup.$refs.popup) popup.$refs.popup.show();
				// this.CommunicationPopup=true;
			},
			loadWeek(callback){
				this.noCacheUpdate=true;
				let dateRange={}

				if(this.loadingNextWeek){
					// this.lazyDate=moment(this.lazyDate).add(7, 'days').format('YYYY-MM-DD');
					let ndate=moment(this.lastDay).add(7, 'days').format('YYYY-MM-DD');
					this.lastDay=getWeeksLimits(ndate, this.$generalSettings.settings.firstDayOfWeek).obj.to;
					dateRange=getWeeksLimits(this.lastDay, this.$generalSettings.settings.firstDayOfWeek)
				}else{
					// this.lazyDate=moment(this.lazyDate).add(-7, 'days').format('YYYY-MM-DD');
					let ndate=moment(this.firstDay).add(-7, 'days').format('YYYY-MM-DD');
					this.firstDay=getWeeksLimits(ndate, this.$generalSettings.settings.firstDayOfWeek).obj.from;
					dateRange=getWeeksLimits(this.firstDay, this.$generalSettings.settings.firstDayOfWeek)
				}
				// this.debug="loadNextweek true - " + this.$refs.weekScroll.scrollLeft + " - "+(this.$refs.weekScroll.offsetWidth*7-this.$refs.weekScroll.offsetWidth)/2+" - "+ this.lazyDate +"<br><br>weekrange: "+this.weekrange.str.from+' - '+this.weekrange.str.to+"<br><br>page: "+this.page+"<br><br>"+this.debug;

				this.$apollo.query({
                    query: USERASSIGNMENTS,
                    fetchPolicy: 'network-only',
					variables: {
						userProfileID: this.userProfileID,
						dateRange: dateRange.str,
						first: 250,
					}
				}).then((data) => {

					if(this.loadingNextWeek){
						this.headerWeekrange.obj.to=dateRange.obj.to;
						this.headerWeekrange.str.to=dateRange.str.to;

						this.loadingNextWeek=false;
						this.userAssignments.data=this.userAssignments.data.concat(data.data.userAssignments.data)
						this.weekdays=this.computeWeekdays(this.userAssignments);
					}else if(this.loadingPrevWeek){
						this.headerWeekrange.obj.from=dateRange.obj.from;
						this.headerWeekrange.str.from=dateRange.str.from;

						this.userAssignments.data=this.userAssignments.data.concat(data.data.userAssignments.data)
						this.weekdays=this.computeWeekdays(this.userAssignments);
						if(callback) callback(true);
						this.loadingPrevWeek=false;
					}
					this.noCacheUpdate=false;

				})
			},
			confirmAssignmentCancel(assignmentID=null){
				if(!assignmentID) return;
				this.noCacheUpdate=true;
				this.$apollo.mutate({
                    mutation: CONFIRMASSIGNMENTCANCEL,
                    variables: {
                        id: assignmentID,
                    }
				}).then(function(data){
					let assignment=data.data.confirmAssignmentCancel;
					this.userAssignments.data=this.userAssignments.data.filter(function(e){
						return e.id!=assignment.id;
					})
					this.weekdays=this.computeWeekdays(this.userAssignments);
					this.$eventBus.$emit('notifications-count', { projectID: this.projectID } )
				}.bind(this))
			},
			acceptAssignment(option, assignmentID=null){
				if(option.reason) this.lastDenyReason=option.reason;
				this.noCacheUpdate=true;
				this.$apollo.mutate({
                    mutation: ACCEPTNOTIFICATIONASSIGNMENT,
                    variables: {
                        assignmentID: assignmentID,
                        userProfileID: this.userProfileID,
                        action: option.value,
                        message: option.reason,
                        page: 1,
						first: 1,
						result: true
                    }
				}).then(function(data){
					let assignment=data.data.acceptAssignment.data[0];
					this.userAssignments.data=this.userAssignments.data.filter(function(e){
						return e.id!=assignment.id;
					})
					this.userAssignments.data.push(assignment)
					// this.userAssignments.data=this.userAssignments.data.concat( this.computeAssignments( {data: [assignment]} ) );
					this.weekdays=this.computeWeekdays(this.userAssignments);
					this.$eventBus.$emit('notifications-count', { projectID: this.projectID } )
				}.bind(this))
				
			},
			fixAbsencesPosition(){
				clearTimeout(this.bodyScollTo)
				this.bodyScollTo=setTimeout(function(){
					this.absencesTop=window.pageYOffset || document.documentElement.scrollTop;
				}.bind(this), 100)
			}
		},
		mounted(){
			this.headerWeekrange=getWeeksLimits(this.currentDate, this.$generalSettings.settings.firstDayOfWeek);
			this.lastDay=this.headerWeekrange.obj.to
			this.firstDay=this.headerWeekrange.obj.from
			if(!this.inboxUserProfileID){
				this.userProfileID=this.myProfile.id;
			}else{ 
				this.userProfileID=this.inboxUserProfileID
			}
			this.lazyDate=this.currentDate;

			this.$eventBus.$emit('notifications-count', { projectID: this.projectID } )

			this.absencesTop=window.pageYOffset || document.documentElement.scrollTop;

			document.addEventListener("scroll", this.fixAbsencesPosition);
		},
        beforeDestroy() {
            document.removeEventListener('scroll', this.fixAbsencesPosition);
			clearTimeout(this.bodyScollTo)
		},
        apollo: {
			myProfile: {
                query: MYPROFILE,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
				},
				update(data){
					if(!this.inboxUserProfileID) this.userProfileID=data.myProfile.id
					return data.myProfile
				}
			},
			userAssignments: {
				query: USERASSIGNMENTS,
				fetchPolicy: 'cache-and-network',
				// debounce: 500,
				variables(){
					let variables={
						userProfileID: this.userProfileID,
						dateRange: this.weekrange.str,
						first: 250,
                        includePast: true
					}
					return {
						...variables
					}
				},
				update(data){
					if(!this.noCacheUpdate){
						this.weekdays=this.computeWeekdays(data.userAssignments);

						this.loadingNextWeek=true;
						this.loadingPrevWeek=true;
						this.$nextTick(function(){
							if(data.userAssignments.data[0]){
								this.scrollToEvent(data.userAssignments.data[0])
							}else{
								this.scrollToEvent(null)
							}
						}.bind(this))


						
						// this.loadingNextWeek=false;
						// this.loadingPrevWeek=false

						return data.userAssignments;
					}else{
						this.noCacheUpdate=false;
						return this.userAssignments;
					}
				}
			},
			userAbsences: {
				query: USERABSENCES,
				fetchPolicy: 'cache-and-network',
				variables(){
					let variables={
						userProfileID: this.userProfileID,
						dateRange: this.weekrange.str,
					}
					return {
						...variables
					}
				},
				update(data){
					let dr=getDatesBetween(this.weekrange.str.from, this.weekrange.str.to)
					dr=dr.map(obj=>moment(obj).format('YYYY-MM-DD'));
					this.datedAbsences={};
					dr.forEach(function(day){
						if(!this.datedAbsences[day]) this.datedAbsences[day]=[];
					}.bind(this))
					data.userAbsences.data.forEach(function(absence){
						if(!this.datedAbsences[absence.date]) this.datedAbsences[absence.date]=[];
						this.datedAbsences[absence.date].push(absence);
					}.bind(this))
				}
			}
		}
	}
</script>
<style lang="scss">
	@import "@/scss/components/dashboard/Schedule.scss";


	.c-load-prev-week, .c-load-next-week{
		display: block;
		position: fixed;
		top: 50%;
		background-color: $white;
		color: $white;
		z-index: 500;
		pointer-events: none;
		border-radius: 50%;
		width: 100px;
		height: 80px;
		opacity: 0;
	}
	.c-load-prev-week {
		left: -80px;
		svg {
			position: absolute;
			top: 50%;
			transform: translateY(-50%);
			right: 10px;
		}
	}
	.c-load-next-week {
		right: -80px;
		svg {
			position: absolute;
			top: 50%;
			transform: translateY(-50%);
			left: 10px;
		}
	}
	.-pendingload {
		& .c-load-prev-week {
			left: -50px;
			opacity: 1;
		}
		& .c-load-next-week {
			right: -50px;
			opacity: 1;
		}
	}


</style>
